import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Typography, Grid, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/InfoOutlined';

const PREFIX = 'CzyFormControl';

const classes = {
  root: `${PREFIX}-root`,
  tooltip: `${PREFIX}-tooltip`,
};

const StyledGrid = styled(Grid)(({ theme: { spacing } }) => ({
  [`&.${classes.root}`]: {
    paddingTop: spacing(0.5),
    paddingBottom: spacing(0.5),
  },

  [`& .${classes.tooltip}`]: {
    maxWidth: 500,
  },
}));

interface CzyFormControlProps {
  label?: string;
  tooltip?: string;
  children?: React.ReactNode;
}

export type _CzyFormControlProps = CzyFormControlProps;

const CzyFormControl: React.FC<_CzyFormControlProps> = ({ children, label, tooltip }) => {
  const hasTooltip = !!tooltip;
  const hasLabel = !!label;
  let smWidth: 1 | 2 | undefined = undefined;
  if (hasTooltip || hasLabel) {
    smWidth = 2;
  }
  if (hasTooltip && hasLabel) {
    smWidth = 1;
  }
  return (
    <StyledGrid container alignItems="center" className={classes.root}>
      {hasLabel && (
        <Grid item sm={smWidth} xs={hasTooltip ? 10 : 12}>
          <Typography variant="subtitle1">
            <b>{label}</b>
          </Typography>
        </Grid>
      )}
      {hasTooltip && (
        <Grid item sm={smWidth} xs={hasLabel ? 2 : 12}>
          <Tooltip title={<span style={{ whiteSpace: 'pre-wrap' }}>{tooltip!}</span>} classes={{ tooltip: classes.tooltip }}>
            <InfoIcon />
          </Tooltip>
        </Grid>
      )}

      <Grid item sm={10} xs={12}>
        {children}
      </Grid>
    </StyledGrid>
  );
};

export default CzyFormControl;
